<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <filterByStatus
            pageTitle="ĐĂNG KÝ PHÒNG HỌP ĐỘT XUẤT"
          />
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view view-with__extendBar">
        <div class="list-docs wrapper-content__main">
          <subHeader>
            <template #content>
              <div class="leftSection">
                <el-button
                  size="medium"
                  type="success"
                  class="createNew"
                  v-if="hcFlow !== null"
                  @click="isOpenDialogCreate = true"
                >
                  <div class="flex-row flex__center">
                    <i class="fas fa-plus-circle font-size__large"></i>
                    <span>&nbsp;&nbsp;THÊM MỚI</span>
                  </div>
                </el-button>
              </div>
              <searchTemplate
                :keyword="searchKey"
                @simpleSearch="search"
                :isDisableAdvanceSearch="true"
              ></searchTemplate>
              <div class="flex-row">
                <span class="font-size__small">Từ</span>
                <VueCtkDateTimePicker
                  color="#2d3e4f"
                  button-color="#2d3e4f"
                  :minute-interval="15"
                  :no-label="true"
                  label
                  :no-header="true"
                  :only-date="true"
                  v-model="startTimePicker"
                  class="custome-picker"
                  format="DD-MM-YYYY"
                  formatted="L"
                  :right="true"
                />
                <span class="font-size__small">Đến</span>
                <VueCtkDateTimePicker
                  color="#2d3e4f"
                  button-color="#2d3e4f"
                  :minute-interval="15"
                  :no-label="true"
                  label
                  :no-header="true"
                  :only-date="true"
                  v-model="endTimePicker"
                  class="custome-picker"
                  format="DD-MM-YYYY"
                  formatted="L"
                  :right="true"
                />
              </div>
            </template>
          </subHeader>

          <dangxulyMainContent
            ref="mainContent1"
            v-if="processing"
            @viewDetail="viewDetail"
            @sortByCreateTime="sortByCreateTime"
            @sortByUpdateTime="sortByUpdateTime"
            @infiniteHandler="infiniteHandlerProcessing"
            :data="processingRooms"
          ></dangxulyMainContent>

          <daxulyMainContent
            ref="mainContent2"
            v-if="!processing"
            @viewDetail="viewDetail"
            @sortByCreateTime="sortByCreateTime"
            @sortByUpdateTime="sortByUpdateTime"
            @infiniteHandler="infiniteHandlerProcessed"
            :data="processedRooms"
          ></daxulyMainContent>

          <createRegisterRoomDialog
            :isOpen="isOpenDialogCreate"
            :id="selectedRoomId"
            :flowId="flowId"
            :flowCode="flowCode"
            v-if="isEnableDialogCreate"
            @dialogClosed="isEnableDialogCreate = false"
            @closeDialog="closeDialog"
            @success="createDialogSuccess"
          />
        </div>
      </div>
      <div class="extendBar">
        <div class="extendItem" @click="viewCalendar">
          <el-tooltip class="item" effect="dark" content="Xem lịch đặt phòng họp" placement="top">
            <img src="../../../assets/img/new-symbol/Calender.svg" alt="calendar-icon">
          </el-tooltip>
        </div>
      </div>
    </template>
  </listTemplate>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import headerTemplate from "../../../components/header/main-header.vue";
import listTemplate from "../../common/list";
import searchTemplate from "../../common/search.vue";
import dangxulyMainContent from "../components/dangxulyMainContent.vue";
import daxulyMainContent from "../components/daxulyMainContent.vue";
import hanhchinhService from "../../../services/hanhchinhService";
import utils from "../../../services/utils";
import moment from "moment";
import { EventBus } from "../../../event-bus.js";
export default {
  components: {
    headerTemplate,
    searchTemplate,
    dangxulyMainContent,
    daxulyMainContent,
    listTemplate,
    VueCtkDateTimePicker,
    filterByStatus: () => import('../components/filter-by-status-header.vue'),
    subHeader: () => import("../../../components/main/sub-header.vue"),
    createRegisterRoomDialog: () =>
      import("./PhongHopDx_Form.vue")
  },
  created() {
    this.getProcedureInformation();
    let d = new Date();
    let currentYear = d.getFullYear();
    let defaultStarTime = `01/01/${currentYear}`;
    let defaultEndTime = `31/12/${currentYear}`;
    this.startTimePicker = defaultStarTime;
    this.endTimePicker = defaultEndTime;
  },
  mounted() {
    EventBus.$on("eventCalled", options => {
      this.reloadPage();
    });
  },

  destroyed() {
    // Stop listening the event with handler
    EventBus.$off("eventCalled");
  },
  watch: {
    isOpenDialogCreate(newValue) {
      newValue && (this.isEnableDialogCreate = newValue);
    },
    isEnableDialogCreate(newValue) {
      !newValue && (this.selectedRoomId = null);
    },
    processedRooms(newValue) {
      if (newValue !== this.processedRooms) {
        this.processedRooms = newValue;
      }
    },
    processingRooms(newValue) {
      if (newValue !== this.processingRooms) {
        this.processingRooms = newValue;
      }
    },
    startTimePicker(newValue) {
      if (newValue !== null) {
        this.startTime = moment(newValue + " 00:00", "DD/MM/YYYY HH:mm").format("x");
      } else {
        this.startTime = null;
      }
      this.reloadPage();
    },
    endTimePicker(newValue) {
      if (newValue !== null) {
        this.endTime = moment(newValue + " 23:59", "DD/MM/YYYY HH:mm").format("x");
      } else {
        this.endTime = null;
      }
      this.reloadPage();
    }
  },
  data() {
    return {
      startTimePicker: null,
      endTimePicker: null,
      processing: false,
      processedRooms: [],
      processingRooms: [],
      hcFlow: null,
      flowCode: "PHONG_HOP_DX",
      flowId: null,
      selectedRoomId: null,
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,
      endTime: null,
      startTime: null,
      processingPage: 0,
      processedPage: 0,
      size: 10,
      sortProcessing: "createTime",
      sortProcessed: "updateTime",
      order: "desc",
      searchKey: null
    };
  },
  methods: {
    viewDetail(e) {
      let caseMasterId = e.caseMasterId;
      let params = utils.merge(this.$route.params, { id: caseMasterId });
      this.$router.push({
        name: "adminstration-detail-dx",
        params: params,
        query: null
      });
    },

    viewCalendar() {
      let params = utils.merge(this.$route.params);
      this.$router.push({
        name: "adminstration-dx-regisRoomCalendar",
        params: params,
        query: null
      });
    },

    closeDialog() {
      this.isOpenDialogCreate = false;
    },

    createDialogSuccess() {
      this.isOpenDialogCreate = false;
      this.reloadPage();
    },

    getProcedureInformation() {
      return hanhchinhService
        .getProcedureInformation(this.flowCode)
        .then(response => {
          if (response.data.hcFlow !== null) {
            this.hcFlow = response.data.hcFlow;
            this.flowId = this.hcFlow.id;
          }
        });
    },

    reloadPage() {
      this.processingPage = 0;
      this.processedPage = 0;
      this.processedRooms = [];
      this.processingRooms = [];

      if (this.$refs.mainContent1) {
        this.$refs.mainContent1.$refs.infiniteLoading.stateChanger.reset();
      }
      if (this.$refs.mainContent2) {
        this.$refs.mainContent2.$refs.infiniteLoading.stateChanger.reset();
      }
    },

    toProcessing() {
      this.processing = true;
    },

    toProcessed() {
      this.processing = false;
    },

    sortByCreateTime(e) {
      this.order = e.sortOrder;
      this.sortProcessed = e.sortBy;
      this.sortProcessing = e.sortBy;
      this.reloadPage();
    },

    sortByUpdateTime(e) {
      this.order = e.sortOrder;
      this.sortProcessed = e.sortBy;
      this.sortProcessing = e.sortBy;
      this.reloadPage();
    },

    search(keyword) {
      this.searchKey = keyword;
      this.reloadPage();
    },

    infiniteHandlerProcessed($state) {
      let pageable = {
        page: this.processedPage,
        size: this.size,
        sort: [this.sortProcessed, this.order].join(",")
      };
      hanhchinhService
        .getProcessed(
          this.flowCode,
          this.startTime,
          this.endTime,
          this.searchKey,
          pageable
        )
        .then(response => {
          let items = response.data.data;
          if (items.length > 0) {
            this.processedRooms.push(...items);
            $state.loaded();
            this.processedPage++;
          } else {
            $state.complete();
          }
        });
    },

    infiniteHandlerProcessing($state) {
      let pageable = {
        page: this.processingPage,
        size: this.size,
        sort: [this.sortProcessing, this.order].join(",")
      };
      hanhchinhService
        .getProcessing(
          this.flowCode,
          this.startTime,
          this.endTime,
          this.searchKey,
          pageable
        )
        .then(response => {
          let items = response.data.data;
          if (items.length > 0) {
            this.processingRooms.push(...items);
            $state.loaded();
            this.processingPage++;
          } else {
            $state.complete();
          }
        });
    }
  }
};
</script>

<style scoped>
.filterBtngroup {
  display: flex;
}

.filterBtn {
  padding: 10px 30px;
  box-shadow: 0 4px 3px -3px #dcdcdc;
}

.filterBtn:hover {
  background-color: #025cab;
  color: #fff;
}

.filterBtn:focus {
  background-color: #025cab;
  color: #fff;
}

.actived {
  background-color: #025cab;
  color: #fff;
}

.myFooter {
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  bottom: 0;
  right: 24px;
  left: 24px;
  min-height: 60px;
  border-radius: 2px;
  /* width: 100%; */
  background: #f4f4f4;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/phonghop/PhongHopDx_Index.vue